module.exports = __webpack_public_path__ + "static/media/md-cafe.976350ec.svg";